module.exports = __webpack_public_path__ + "static/media/PeersBlack.2a5904f9.svg";